import { ChangeDetectionStrategy, HostListener, Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';
import { FatDoctoC } from '../../../../../shared/interfaces/fat-docto-c';
import { AppConfirmService } from '../../../../../shared/services/app-confirm/app-confirm.service';

@Component({
  selector: 'app-lancamento-nfe',
  templateUrl: 'lancamento-nfe.component.html',
  styleUrls: ['lancamento-nfe.component.scss'],
})
export class LancamentoNfeComponent implements OnInit, OnDestroy {

  public doctoCForm: FormGroup;
  lcto: FatDoctoC;

  @HostListener('window:keyup.esc') onKeyUp() {
    if (this.dialog.openDialogs.length > 0) {
      console.log('@HostListener(window:keyup.esc) onKeyUp()');
      this.confirmService.confirm({ message: `Deseja realmente fechar? Poderá haver perda de dados.` })
      .subscribe(res => {
        if (res) {
          this.dialogRef.close();
        }
      });     
    }
  }

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<LancamentoNfeComponent>,
    private dialog: MatDialog,
    private confirmService: AppConfirmService,
  ) {
  }  

  ngOnInit() {
    console.log('INIT Transp');    
    this.doctoCForm = this.data.payload;
    this.lcto = this.doctoCForm.value;
  }


  ngOnDestroy() {
  }
    
  close() {
    this.confirmService.confirm({ message: `Deseja realmente fechar? Poderá haver perda de dados.` })
      .subscribe(res => {
        if (res) {
            this.dialogRef.close();
        }
      });
  }

}
